export const isLoadingDbLogHeadersSelector = state => state.administration.databaseLogs.isLoadingDbLogHeaders;
export const isLoadingDbLogDetailSelector = state => state.administration.databaseLogs.isLoadingDbLogDetail;

export const dbLogHeadersSelector = state => state.administration.databaseLogs.dbLogHeaders;
export const dbLogDetailSelector = state => state.administration.databaseLogs.dbLogDetail;
